module.exports = __webpack_public_path__ + "static/media/sobrenos_odonto.e7d2603c.png";